import { createSlice } from "@reduxjs/toolkit";

export const groupSlice = createSlice({
  name: "group",
  initialState: {
    getGroupResult: false,
    getGroupLoading: false,
    getGroupError: false,
    addGroupResult: false,
    addGroupLoading: false,
    deleteGroupResult: false,
  },
  reducers: {
    groupReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_GROUP":
          return {
            ...state,
            getGroupResult: payload.data,
            getGroupLoading: payload.loading,
            getGroupError: payload.error,
          };
        case "ADD_GROUP":
          return {
            ...state,
            addGroupResult: payload.data,
            addGroupLoading: payload.loading,
          };
        case "DELETE_GROUP":
          return {
            ...state,
            deleteGroupResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { groupReducers } = groupSlice.actions;

export default groupSlice.reducer;
